import { takeEvery } from 'redux-saga/effects';
import { fetchProducts, onDeleteProduct } from '../slice';
import { deleteProductInstance } from './deleteProductInstanceSaga';
import { getProducts } from './productsSaga';

const productsSagas = [
    takeEvery(fetchProducts.type, getProducts),
    takeEvery(onDeleteProduct.type, deleteProductInstance),
];

export default productsSagas;
